import React from 'react';
import Close from 'src/assets/images/CloseProduct.svg';
import { useDispatch, useSelector } from 'react-redux';
import {
    CloseIconContainer,
    CloseIcon,
    HeaderContainer,
    HeaderDetails,
    HeaderSpan,
    AccountHeaderFont,
    AccountSubHeaderFont,
    FavouriteIcon,
    FavoriteIconContainer,
    BackButtonIcon,
    BackButtonContainer,
    BackText,
} from './AccountHeader.styled';
import FavoriteActive from 'src/assets/images/FavoriteActive.svg';
import FavoriteInActive from 'src/assets/images/favorite-inactive.svg';
import { setFavoriteIcon } from 'src/pages/more/redux/actions';
import BackIcon from 'src/assets/images/ArrowLeftLight.svg';
import { useTranslation } from 'react-i18next';
import {
    CC_USER_ROLE,
    CSR_USER_ROLE,
    ITA_USER_ROLE,
} from 'src/constants/appConstants';
import { accountNumberZeroTrimmer, logErrorToConsole } from 'src/utils/util';

const AccountDetailHeader = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { isFromPhysician } = props;
    const accountDetailsMain = useSelector(
        (state) => state.accountReducer.accountDetails
    );
    return (
        <>
            {' '}
            {isFromPhysician ? (
                // <BackToPhysician>
                //     <BackButtonIcon src={BackIcon} />
                //     <a onClick={props.onClose}> Back to Physician Details</a>
                // </BackToPhysician>
                <BackButtonContainer margin={'0'} style={{ cursor: 'pointer' }}>
                    <BackButtonIcon onClick={props.onClose} margin={'0 0 0 0px'} src={BackIcon} />
                    <BackText>
                        <a onClick={props.onClose}>
                            {' '}
                            {t(
                                'accounts.accountDetailHeader.backToPhysicianDetails'
                            )}
                        </a>
                    </BackText>
                </BackButtonContainer>
            ) : null}
            <HeaderContainer>
                <HeaderDetails>
                    <AccountHeaderFont isDemi>
                        {props.selectedAccount.accountName}
                    </AccountHeaderFont>
                </HeaderDetails>
                {props.employeeRole !== CC_USER_ROLE &&
                    props.employeeRole !== ITA_USER_ROLE &&
                    props.employeeRole !== CSR_USER_ROLE && (
                        <FavoriteIconContainer
                            value={props.selectedAccount.accountId}
                        >
                            <FavouriteIcon
                                mobilePath={
                                    // isInstantFavorite
                                    accountDetailsMain &&
                                    accountDetailsMain.isFavourite === true
                                        ? FavoriteActive
                                        : FavoriteInActive
                                }
                                onClick={() => {
                                    try {
                                    dispatch(
                                        setFavoriteIcon(
                                            props.selectedAccount.accountId,
                                            accountDetailsMain &&
                                                !accountDetailsMain.isFavourite,
                                            props.isFromPhysician,
                                            //false,
                                            props.fromSearch,
                                            props.selectedAccount?.districtAndTerritory?.[0]?.territoryCode
                                        )
                                    );
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                            />
                        </FavoriteIconContainer>
                    )}
                {/* <CloseIconContainer paddingRight={'3px'}>
                    <CloseIcon
                        mobilePath={Close}
                        onClick={props.onClose}
                        show={true}
                    />
                </CloseIconContainer> */}
            </HeaderContainer>
            <HeaderSpan>
                {t('accounts.accountDetailHeader.account')}{' '}
                {accountNumberZeroTrimmer(props.selectedAccount.accountId)}
            </HeaderSpan>
            <AccountSubHeaderFont isRegular>
                {props.accountDet &&
                    props.accountDet.address &&
                    props.accountDet.address.town}
                {props.accountDet &&
                    props.accountDet.address &&
                    props.accountDet.address.region &&
                    ', '}
                {props.accountDet &&
                    props.accountDet.address &&
                    props.accountDet.address.region &&
                    props.accountDet.address.region}
            </AccountSubHeaderFont>
            {/* {isCross ? (
                <UnsavedChanges
                    onDiscard={handleDiscardChanges}
                    onClose={handleSaveAndExit}
                    continueText={'Continue and Edit'}
                    fromSettingsClose={fromSettingsClose}
                />
            ) : null} */}
        </>
    );
};

export default AccountDetailHeader;
